import { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { fetchCodes, deleteCode, addCode, updateCode } from '../../apis/home/codes';
import toast, { Toaster } from 'react-hot-toast';

export default function DiscountPage() {

    const [promoCodes, setPromoCodes] = useState([]);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [newCode, setNewCode] = useState({ code: '', discount: '' });
    const [loading, setLoading] = useState(false);
    const [isEdit, setisEdit] = useState(false);
    const [editCode, seteditCode] = useState(null);

    const openDialog = () => setDialogVisible(true);
    const hideDialog = () => {
        setDialogVisible(false);
        setisEdit(false);
    };

    const handleKeyPress = (e) => {
        const regex = /^[a-zA-Z0-9]$/;
        if (!regex.test(e.key)) {
            e.preventDefault();
        }
    };

    const getCodes = async () => {

        try {
            setLoading(true);

            console.log('Getting Codes');

            const codes = await fetchCodes();

            console.log(codes);

            setPromoCodes(codes);
        } catch (error) {
            console.log('31 -error - get Codes');
            toast.error('Error: Fetching Codes');
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getCodes();
    }, []);

    function validatePromoCode(code) {
        const regex = /^[A-Za-z0-9]+$/;
        return regex.test(code);
    }


    const saveCode = async () => {

        try {

            setLoading(true);

            if (isEdit) {
                if (!editCode.code || !editCode.discount) {
                    toast.error('Please provide both code and discount!');
                    return;
                }

                if (!validatePromoCode(editCode.code)) {
                    toast.error("Promo code must be alphanumeric only.");
                    return;
                }

                await updateCode(editCode);
                toast.success('Promo Code Updated');
            } else {

                if (!newCode.code || !newCode.discount) {
                    toast.error('Please provide both code and discount!');
                    return;
                }

                if (!validatePromoCode(newCode.code)) {
                    alert("Promo code must be alphanumeric only.");
                    return;
                }

                console.log(newCode);
                await addCode(newCode);


                toast.success('Promo Code Added');
            }

            setNewCode({ code: '', discount: '' }); // clear form
            hideDialog();
        } catch (error) {
            toast.error(!isEdit ? 'Error: Adding Category' : 'Error: Editing Category');
        } finally {
            setLoading(false);
            setTimeout(() => {
                getCodes();
            }, 1000);
        }
    };

    const handleEdit = (item) => {
        console.log(item);

        setisEdit(true);
        setDialogVisible(true);
        seteditCode(item);
    };

    const handleDelete = async (item) => {
        try {
            await deleteCode(item.codeId);
            toast.success('Code Deleted');
            setPromoCodes(prev => prev.filter(b => b.codeId !== item.codeId));
        } catch (error) {
            toast.error('Error: Deleting Category');
        } finally {
            setLoading(false);
        }
    };

    const actionTemplate = (rowData) => (
        <div className="p-d-flex p-ai-center gap-2">
            <Button
                icon="pi pi-pencil"
                className="p-button-text"
                tooltip="Edit Promo Code"
                onClick={() => handleEdit(rowData)}
            />
            <Button
                icon="pi pi-trash"
                className="p-button-text p-button-danger"
                tooltip="Delete Promo Code"
                onClick={() => handleDelete(rowData)}
            />
        </div>
    );

    return (
        <>
            <Toaster />
            <h2>Promo Codes</h2>

            <Button label="Add Promo Code" icon="pi pi-plus" onClick={openDialog} />

            <Dialog header={isEdit ? 'Edit Promo Code' : 'Add Promo Code'} visible={dialogVisible} onHide={hideDialog}>
                <div className="flex flex-col gap-3">

                    {
                        isEdit ?
                            <>
                                <div className="p-field p-col-12" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    <label htmlFor="promoCode">Promo Code</label>
                                    <InputText placeholder="e.g - ABCD20" value={editCode.code} onKeyPress={handleKeyPress} onChange={(e) => seteditCode({ ...editCode, code: e.target.value })} />
                                </div>
                                <div className="p-field p-col-12" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    <label htmlFor="promoCode">Discount %</label>
                                    <InputText placeholder="e.g - 5" keyfilter="int" value={editCode.discount} onChange={(e) => seteditCode({ ...editCode, discount: e.target.value })} />
                                </div>
                            </>
                            :
                            <>
                                <div className="p-field p-col-12" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    <label htmlFor="promoCode">Promo Code</label>
                                    <InputText placeholder="e.g - ABCD20" maxLength={12} onKeyPress={handleKeyPress} onChange={(e) => setNewCode({ ...newCode, code: e.target.value })} />
                                </div>
                                <div className="p-field p-col-12" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    <label htmlFor="promoCode">Discount %</label>
                                    <InputText placeholder="e.g - 5" keyfilter="int" onChange={(e) => setNewCode({ ...newCode, discount: e.target.value })} />
                                </div>
                            </>
                    }
                    <div style={{ paddingTop: '2rem' }}>
                        <Button loading={loading} label="Save" icon="pi pi-check" onClick={saveCode} />
                    </div>
                </div>
            </Dialog>

            <div className="p-m-3 mt-4">
                <DataTable value={promoCodes} loading={loading} emptyMessage='No Promo Codes Found'>
                    <Column field="code" header="Promo Code" />
                    <Column field="discount" header="Discount (%)" />
                    <Column header="Actions" body={actionTemplate} />
                </DataTable>
            </div>
        </>
    );
}